var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manager"},[_c('div',{staticClass:"title"},[_vm._v("插件管理")]),_vm._v(" "),_c('div',{staticClass:"grids"},[_vm._l((_vm.plugins),function(p){return _c('plugin',{key:p.name,attrs:{"plugin":p,"delete":_vm.deletePlugin,"setDisabled":_vm.setPluginDisabled}})}),_vm._v(" "),_c('add',{attrs:{"add":_vm.addPlugin}})],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8806cd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/manager/components/plugins/index.vue
// module id = 436
// module chunks = 0